import GDPR from './GDPR';

export default GDPR;
